module.exports = __webpack_public_path__ + "img/1-3.ed17296f.svg";